export default __webpack_public_path__ + "static/weshooter-fbc90e6b62330f96bf5b2f755488eab2.gif";